import { useEffect } from 'react';

export const MA_EVINA_SCRIPT_SECOND_CHALLENGE = 'dvpassDCBProtectChallengeSecond';

export const useMoroccoDVHEFlowOTP = () => {
  const MAHESecondClickId = sessionStorage.getItem(MA_EVINA_SCRIPT_SECOND_CHALLENGE) || '';

  useEffect(() => {
    return () => {
      sessionStorage.removeItem(MA_EVINA_SCRIPT_SECOND_CHALLENGE);
    };
  }, []);

  return MAHESecondClickId;
};
